import Vue from 'vue'
import Router from 'vue-router'
import Admin from './views/Admin.vue'
import Error404 from './views/Error404.vue'
import SvgPerf from './views/SvgPerf/index.vue'
import AnnualSvgPerf from './views/SvgPerf/annual.vue'

Vue.use(Router)

export default new Router({
  //mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: Error404
    },
		{
			path: '/school/:schoolID/:year/:month',
			name: 'school',
			component: SvgPerf,
    },
    {
      path: '/annual/:schoolID',
      name: 'annual',
      component: AnnualSvgPerf,
    },
    {
      path: '/admin',
      name: 'admin',
      component: Admin
    },
    {
      path: '/test',
      component: SvgPerf
    }
  ]
})
